/**
 * Redux Thunk middleware allows you to write action creators that return a function instead of an action.
 * The thunk can be used to delay the dispatch of an action, or to dispatch only if a certain condition is met.
 * The store maintains global app data. This can be accessed by any component irrespective of hierarchy.
 * */

// Stores
import { createStore, applyMiddleware} from 'redux'
import { composeWithDevTools} from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import rootReducer from '../reducers'
// Sagas
import createSagaMiddleware from 'redux-saga'

const initialState ={};

export const sagaMiddleware = createSagaMiddleware();

const middleware =[thunk, sagaMiddleware];
// TODO: Investigate and remove this deprecation
export const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));
